export default __webpack_public_path__ + "static/media/mantle004.f461a326.jpeg";